<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="addshop">
          <div class="content_search">
            <div class="input_inner">
              <el-input
                v-model="fromData.keyword"
                clearable
                @clear="handleClear"
                placeholder="请输入商品编号/商品名称"
              ></el-input>
            </div>
            <div class="input_inner">
              <el-cascader
                placeholder="请选择商品分类"
                :options="shopcateArr"
                :props="defaultProps"
                filterable
                clearable
                @change="handleCascader"
                v-model="cate_ids"
              ></el-cascader>
            </div>
            <div class="input_inner">
              <el-select
                v-model="fromData.type"
                @clear="handleClear"
                filterable
                clearable
                placeholder="请选择商品类型"
              >
                <el-option
                  v-for="item in typaArr"
                  :key="item.cate_id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_inner dis-flex">
              <el-input
                v-model="fromData.min_price"
                clearable
                @clear="handleClear"
                placeholder="请输入价格"
              ></el-input>
              <div class="dis-flex-line"></div>
              <el-input
                v-model="fromData.max_price"
                clearable
                @clear="handleClear"
                placeholder="请输入价格"
              ></el-input>
            </div>
            <div class="input_inner">
              <el-date-picker
                v-model="times"
                @change="handleClear"
                type="daterange"
                range-separator="~"
                start-placeholder="创建开始时间"
                end-placeholder="创建结束时间"
                value-format="timestamp"
                clearable
              >
              </el-date-picker>
            </div>
            <div class="search-btn search-btn1" @click="handleSearch">查询</div>
            <div class="search-btn seach-blue" @click="handleReset">重置</div>
          </div>
          <div class="ztabbar">
            <div class="ztabbar-left">
              <div
                :class="[
                  'ztabbar-left-item',
                  item.id == fromData.status ? 'ztabbar-active' : '',
                ]"
                v-for="item in tabbar"
                :key="item.id"
                @click="handleTabbar(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="ztabbar-right">
              <div class="ztabbar-right-active" @click="handleSubmit">
                确认添加
              </div>
            </div>
          </div>
          <div class="pc-table pc-table-color">
            <el-checkbox-group
              v-model="ids"
              @change="handleCheckedCitiesChange"
              :max="dataVal.max"
            >
              <el-table
                :data="list"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                height="50vh"
                style="width: 100%"
              >
                <el-table-column prop="id" align="center" width="55">
                  <template
                    v-if="!dataVal.max"
                    slot="header"
                    slot-scope="scope"
                  >
                    <!-- 全选 -->
                    <img
                      class="checkedimg"
                      v-if="checkAll"
                      @click="handleCheckAllChange(false)"
                      src="@/assets/images/basicBusiness/d1.png"
                      alt=""
                    />
                    <!-- 取消全选 -->
                    <img
                      class="checkedimg"
                      v-if="!isIndeterminate && !checkAll"
                      @click="handleCheckAllChange(true)"
                      src="@/assets/images/basicBusiness/d2.png"
                      alt=""
                    />
                    <!-- 已选中但为全选 -->
                    <img
                      class="checkedimg"
                      v-if="isIndeterminate && !checkAll"
                      @click="handleCheckAllChange(true)"
                      src="@/assets/images/basicBusiness/d3.png"
                      alt=""
                    />
                  </template>
                  <template slot-scope="scope">
                    <div class="checked">
                      <el-checkbox :label="scope.row.id"></el-checkbox>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="bianhao" label="商品编号" width="180">
                  <template slot-scope="scope">
                    <div class="C007AFF">
                      {{ scope.row.bianhao }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="date2"
                  align="left"
                  label="商品"
                  width="300"
                >
                  <template slot-scope="scope">
                    <div class="shopping">
                      <img :src="urls + scope.row.image" alt="" />
                      <div>{{ scope.row.title }}</div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="catename" label="商品分类" width="180">
                </el-table-column>
                <el-table-column prop="price" label="售价" width="140">
                  <template slot-scope="scope">
                    <div style="color: #ef3826">¥{{ scope.row.price }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="originalprice" label="原价" width="140">
                </el-table-column>
                <el-table-column prop="date7" label="状态" width="180">
                  <template slot-scope="scope">
                    <div class="z-box">
                      <div
                        v-if="scope.row.status == 1"
                        class="z-box-item C00B69B"
                      >
                        上架
                      </div>
                      <div
                        v-if="scope.row.status == 0"
                        class="z-box-item EF3826"
                      >
                        待上架
                      </div>
                      <div
                        v-if="scope.row.status == 2"
                        class="z-box-item C7B7B81"
                      >
                        下架
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="sales" label="销量" width="140">
                </el-table-column>
                <el-table-column prop="type" label="商品类型" width="140">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.type == 1 ? "实物商品" : "电子卡券" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" width="180">
                  <template slot-scope="scope">
                    <div>
                      {{
                        (scope.row.createtime * 1000)
                          | formatTimestamp("yyyy-MM-dd hh:mm:ss")
                      }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-checkbox-group>
          </div>
          <div class="pagination">
            <div class="pagination-total">共{{ total_count }}条</div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="fromData.page"
              :page-sizes="[10, 20, 50, 100, 200, 500, total_count]"
              :page-size="fromData.count"
              layout="sizes, prev, pager, next, jumper"
              :total="total_count"
              background
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      tabbar: [
        {
          id: 1,
          name: "已上架",
        },
      ],
      multipleSelection: [],
      list: [],
      total_count: 0,
      fromData: {
        page: 1,
        count: 10,
        type: 1, //商品类型：1=实物商品、2=电子卡券
        keyword: "", //商品名称、编号
        cate_id: "", //所属类目
        status: 1, //状态：0=待上架，1=已上架，2=已下架
        min_price: "", //最低价格
        max_price: "", //最高价格
        stime: "", //创建日期开始
        etime: "", //创建日期结束
        pricetype: 1,
      },
      times: "",
      typaArr: [{ id: 1, name: "实物商品" }],
      cateArr: [],
      urls: this.imgurl,
      shopcateArr: [],
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      cate_ids: [],
      ids: [],

      //多选
      checkAll: false,
      select: [],
      isIndeterminate: false,
    };
  },
  mounted() {},
  methods: {
    handleCheckAllChange(val) {
      let ids = this.list.map((item) => {
        return item.id;
      });
      this.ids = val ? ids : [];
      this.checkAll = val;
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.ids = value;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.list.length;
    },
    //提交
    handleSubmit() {
      if (this.ids.length == 0) {
        this.$message.error("请选择商品");
        return false;
      }

      let obj = {
        flag: false,
        submitFlag: true,
        ids: this.ids,
      };
      this.$emit("addShopCell", obj);
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addShopCell", obj);
    },
    // 获取分类列表
    async shopcatelist(flag) {
      let res = await this.$api.shopcatelist();
      if (res.code == 1) {
        let arr = [];
        //一级
        res.data.forEach((item, i) => {
          if (item.twodata.length != 0) {
            arr.push({
              id: item.id,
              type: 1,
              pid: item.pid,
              name: item.name,
              children: [],
            });
          } else {
            arr.push({
              id: item.id,
              type: 1,
              pid: item.pid,
              name: item.name,
            });
          }
          //二级
          if (item.twodata.length != 0) {
            item.twodata.forEach((item2, i2) => {
              if (item2.threedata.length != 0) {
                arr[i].children.push({
                  id: item2.id,
                  type: 2,
                  pid: item2.pid,
                  name: item2.name,
                  children: [],
                });
              } else {
                arr[i].children.push({
                  d: item2.id,
                  type: 2,
                  pid: item2.pid,
                  name: item2.name,
                });
              }
              // //三级
              if (item2.threedata.length != 0) {
                item2.threedata.forEach((item3, i3) => {
                  if (item3.fourdata.length != 0) {
                    arr[i].children[i2].children.push({
                      id: item3.id,
                      type: 3,
                      pid: item3.pid,
                      name: item3.name,
                      children: item3.fourdata,
                    });
                  } else {
                    arr[i].children[i2].children.push({
                      id: item3.id,
                      type: 3,
                      pid: item3.pid,
                      name: item3.name,
                    });
                  }
                });
              }
            });
          }
        });
        this.shopcateArr = arr;
      }
    },
    handleCascader(val) {
      this.fromData.page = 1;
      this.shopGoodslist();
    },
    // 重置
    handleReset() {
      this.fromData = {
        page: 1,
        count: this.fromData.count,
        type: 1, //商品类型：1=实物商品、2=电子卡券
        keyword: "", //商品名称、编号
        cate_id: "", //所属类目
        status: 1, //状态：0=待上架，1=已上架，2=已下架
        min_price: "", //最低价格
        max_price: "", //最高价格
        stime: "", //创建日期开始
        etime: "", //创建日期结束
        pricetype: 1,
      };
      this.times = "";
      this.cate_ids = [];
      this.shopGoodslist();
    },
    handleClear() {
      this.fromData.page = 1;
      this.shopGoodslist();
    },
    // 查询
    handleSearch() {
      this.fromData.cate_id = this.cate_ids[this.cate_ids.length - 1] || "";
      this.fromData.page = 1;
      this.shopGoodslist();
    },
    //客户列表
    async shopGoodslist() {
      if (this.times) {
        this.fromData.stime = this.times[0] / 1000 || "";
        this.fromData.etime = (this.times[1] / 1000) + 86399 || "";
      } else {
        this.fromData.stime = "";
        this.fromData.etime = "";
      }
      let res = await this.$api.shopGoodslist({
        ...this.fromData,
      });
      if (res.code == 1) {
        this.list = res.data.list;
        this.total_count = res.data.total_count;
      }
    },
    //tabbar点击事件
    handleTabbar(item) {
      this.fromData.status = item.id;
      this.fromData.page = 1;
      this.shopGoodslist();
    },
    //表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val.map((row) => row.id);
    },
    //分页事件
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.fromData.count = val;
      this.shopGoodslist();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.fromData.page = val;
      this.shopGoodslist();
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.ids = newVal.select;
          // console.log(newVal);
          this.shopGoodslist();
          this.shopcatelist();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.el-popper {
  z-index: 10000 !important;
}
.el-popper[x-placement^="right"] {
  z-index: 8888 !important;
}
</style>
<style lang="scss" scoped>
.checkedimg {
  cursor: pointer;
}
.addshop {
  padding: 20px 20px 20px 16px;
  .content_search {
    background-color: #f2f2f7;
    border-radius: 5px;
    padding: 26px 26px 2px;
    /deep/.input_inner {
      width: calc((100% - 48px) / 4);
      margin-right: 12px;
      margin-bottom: 24px;
      .el-select {
        width: 100%;
      }
      .el-range-editor.el-input__inner {
        width: 100% !important;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
    }
    /deep/.input_inner2 {
      width: calc(((100% - 48px) / 4) * 2);
    }
    .search-btn1 {
      margin-left: 0;
    }
    .seach-blue {
      border: 1px solid #007aff;
      color: #007aff;
      background-color: transparent;
    }
    .dis-flex {
      display: flex;
      align-items: center;
      .dis-flex-line {
        width: 13px;
        height: 1px;
        background-color: #000;
        margin: 0 10px;
        flex-shrink: 0;
      }
    }
  }
}
/deep/.checked {
  .el-checkbox__label {
    display: none;
  }
}
.ztabbar-right-active {
  width: 100px;
  height: 40px;
  font-size: $f-size-13;
  color: #fff;
  background-color: $y-color;
  @include flex-center(center, center);
  cursor: pointer;
}
.shopping {
  display: flex;
  img {
    flex-shrink: 0;
    width: 50px;
    height: auto;
    margin-right: 16px;
  }
  div {
    width: 166px;
    text-align: left;
  }
}
</style>
  <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 81.481vw;
  height: 90vh;
  border-radius: 25px;
  background-color: #fff;
  .posi-head {
    padding: 0 64px 0 41px;
    height: 60px;
    @include flex-center(space-between, center);
    background-color: #f2f6ff;
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 28px;
      color: #606060;
      cursor: pointer;
    }
  }
  .posi-over {
    width: 100%;
    padding: 0 30px;
    height: calc(100% - 60px);
    overflow: auto;
  }
}
</style>